export class DocumentExtractionModel {
  constructor(
    public id = 0,
    public documentId =0,
    public insZoomCaseId= "",
    public documentName="",
    public packageType="",
    public eympCaseID="",
    public docCategory = "",
    public docType = "",
    public firstName= "",
    public lastName = "")
    {}
}
